import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7jmjqz03n1: FaireBrandEntity = {
  token: "b_7jmjqz03n1",
  type: "brand",
  name: "Matchaful",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 100,
  meta: {
    source: "mock",
    importedAt: "2026-03-31T00:00:00.000Z",
    importedBy: "ci-fix",
  },
};
